	export class EasingFunctions {

		// no easing, no acceleration
		public static linear(t: number): number { return  t };

		// accelerating from zero velocity
		public static easeInQuad(t: number): number { return  t*t };

		// decelerating to zero velocity
		public static easeOutQuad(t: number): number { return t*(2-t) }

		// acceleration until halfway, then deceleration
		public static easeInOutQuad(t: number): number { return t<.5 ? 2*t*t : -1+(4-2*t)*t }

		// accelerating from zero velocity
		public static easeInCubic(t: number): number { return t*t*t }

		// decelerating to zero velocity
		public static easeOutCubic(t: number): number { return (--t)*t*t+1 }

		// acceleration until halfway, then deceleration
		public static easeInOutCubic(t: number): number { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }

		// accelerating from zero velocity
		public static easeInQuart(t: number): number { return t*t*t*t }

		// decelerating to zero velocity
		public static easeOutQuart(t: number): number { return 1-(--t)*t*t*t }

		// acceleration until halfway, then deceleration
		public static easeInOutQuart(t: number): number { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t }

		// accelerating from zero velocity
		public static easeInQuint(t: number): number { return t*t*t*t*t }

		// decelerating to zero velocity
		public static easeOutQuint(t: number): number { return 1+(--t)*t*t*t*t }

		// acceleration until halfway, then deceleration
		public static easeInOutQuint(t: number): number { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
	}

	export function animate(start: number, stop: number,
		apply: (frame :number) => void, ease = EasingFunctions.linear, duration=1000, speed=10) {

		var tStart = new Date().getTime();
		var distance = (stop - start);

		var loop = setInterval(function() {
			var timePassed = new Date().getTime() - tStart;
			var progress = timePassed / duration;

			if(progress < 1){
				var frame = start + distance * ease(progress);
				apply(frame);
			}
			else {
				apply(stop);
				clearInterval(loop);
			}

		}, speed || 10);

		return {
			cancel: function () {
				clearInterval(loop);
			}
		};
	}
